if (!customElements.get('back-in-stock-form')) {
  customElements.define(
    'back-in-stock-form',
    class BackInStockForm extends HTMLElement {
      constructor() {
        super();
        // Listeners are bound to this outer element (not its children) and children
        // are queried live on each interaction, because Dawn's variant-switch handler
        // replaces this element's innerHTML on every variant change - cached child
        // references or listeners bound directly to children would go stale.
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
      }

      get inner() {
        return this.querySelector('.back-in-stock__inner');
      }

      onClick(event) {
        if (event.target.closest('.back-in-stock__toggle')) {
          this.onToggle();
        } else if (event.target.closest('.back-in-stock__submit')) {
          this.onSubmit();
        }
      }

      onKeydown(event) {
        if (event.key === 'Enter' && event.target.classList.contains('back-in-stock__email')) {
          event.preventDefault();
          this.onSubmit();
        }
      }

      onToggle() {
        const formWrapper = this.querySelector('.back-in-stock__form');
        formWrapper.hidden = !formWrapper.hidden;
        if (!formWrapper.hidden) this.querySelector('.back-in-stock__email').focus();
      }

      showMessage(text, isError) {
        const message = this.querySelector('.back-in-stock__message');
        message.textContent = text;
        message.hidden = false;
        message.classList.toggle('back-in-stock__message--error', Boolean(isError));
      }

      onSubmit() {
        const inner = this.inner;
        const emailInput = this.querySelector('.back-in-stock__email');
        const submitButton = this.querySelector('.back-in-stock__submit');
        const email = emailInput.value.trim();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailPattern.test(email)) {
          this.showMessage(inner.dataset.labelInvalidEmail, true);
          return;
        }

        const companyId = inner.dataset.companyId;
        const variantId = inner.dataset.variantId;

        submitButton.setAttribute('disabled', 'disabled');
        submitButton.textContent = inner.dataset.labelSubmitting;

        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${companyId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2026-07-15',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email },
                  },
                },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        })
          .then((response) => {
            if (response.ok) {
              emailInput.setAttribute('disabled', 'disabled');
              submitButton.remove();
              this.showMessage(inner.dataset.labelSuccess, false);
            } else {
              submitButton.removeAttribute('disabled');
              submitButton.textContent = inner.dataset.labelSubmit;
              this.showMessage(inner.dataset.labelError, true);
            }
          })
          .catch(() => {
            submitButton.removeAttribute('disabled');
            submitButton.textContent = inner.dataset.labelSubmit;
            this.showMessage(inner.dataset.labelError, true);
          });
      }
    }
  );
}
